import * as React from 'react';
import b_ from 'b_';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import { getContent, PRE_IPO_PNL } from '../../../../../content';

import './index.scss';

import * as decorator from './static/img/decorator.svg';

interface Props {
  tabIndex: number;
  index: number;
  onGraphColumnClick?: () => void;
}

type Enhanced = Props & InjectedTranslateProps;

const b = b_.with('main-page-results-content-graph-item');

const Item: React.FC<Enhanced> = ({ t, index, onGraphColumnClick, tabIndex }) => {
  const graphColumn = getContent(t)[tabIndex].graph[index];
  const popupItem = getContent(t)[tabIndex].popup;

  const columnHeight = { height: ` ${graphColumn.height}px` };
  const yearPnl = popupItem?.map((item) => item.subitems.map((item) => item.value));
  const averagePnl = yearPnl && yearPnl[index].reduce((a, b) => a + b) / yearPnl[index].length;
  const withDecorator = averagePnl && averagePnl / graphColumn.height > 10;

  const itemStyles = {
    'color-red': averagePnl && averagePnl < 0,
    clickable: !getContent(t)[tabIndex].nonClickable,
    big: graphColumn.bigColumn,
    small: !graphColumn.bigColumn,
  };

  if (popupItem) {
    const numOfIdeas = popupItem.map((item) => item.subitems.length);

    return (
      <div onClick={onGraphColumnClick} style={columnHeight} className={b(itemStyles)}>
        <div className={b('row')}>
          {
            <div className={b('ideas')}>
              {numOfIdeas[index]} {t('{{count}} ideas', { count: numOfIdeas[index] })}
            </div>
          }
          <div className={b('profit')}>
            {averagePnl && averagePnl > 0 ? '+' : '−'}
            {averagePnl && `${Math.round(Math.abs(averagePnl))}%`}
          </div>
        </div>
        {withDecorator && <img src={decorator} className={b('decorator')} />}
        <div className={b('year')}>{graphColumn.year}</div>
      </div>
    );
  }

  return (
    <div onClick={onGraphColumnClick} style={columnHeight} className={b(itemStyles)}>
      <div className={b('profit')}>
        {averagePnl && averagePnl > 0 && '+'}
        {`${PRE_IPO_PNL[index]}%`}
      </div>
      {withDecorator && <img src={decorator} className={b('decorator')} />}
      <div className={b('year')}>{graphColumn.year}</div>
    </div>
  );
};

export default translate(Item);
